module.exports = __webpack_public_path__ + "img/dq_pic_noon_data_alignment.b7447759.png";